import axios from 'axios';
import {withAuth} from "../utils/authTokens";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_CHATBOT_BACKEND}`,
  headers: {
    'Access-Control-Allow-Origin': '*',
    "Content-Type": "application/json"
  },
});

// token on every request, refreshed before it expires and on a 401 (see withAuth)
withAuth(instance);

export const setBaseURLNeo4j = (url) => {
  instance.defaults.baseURL = url;
};


export default instance;
